<template>
  <div
    class="activity-list"
    id="activity-list"
    v-if="internalActivities.length"
  >
    <header class="activity-header">
      <span>{{ __('Anexos') }}</span>
      <div class="attachment-buttons">
        <button @click="openDocsModal">
          <IconPaperclip />
        </button>
        <button @click="openMediaModal">
          <IconImage />
        </button>
      </div>
    </header>
    <!-- <div 
      v-for="(act, i) in fixedActivities"
      :key="'fixed-activity-' + act.id + '-' + i"
    >
      <LeadActivityItem
        v-if="ACTIVITY_TYPES.includes(act.type.key)"
        :activity="act"
        :deal="deal"
        :hash="hash"
        :user="user"
        :is-deleted="!!act.deleted_at"
        :fixedActivitiesCount="fixedActivitiesCount"
        @updateFixedActivitiesCount="updateFixedActivitiesCount"
        isFixedActivity="true"
        @unpinActivity="updateActivityFixation"
      />
      <hr
        class="divider"
      >
    </div> -->
    <div
      v-for="(activity, index) in internalActivities"
      :key="activity.id + activity.type.key"
    >
      <LeadActivityItem
        v-if="ACTIVITY_TYPES.includes(activity.type.key)"
        :activity="activity"
        :deal="deal"
        :hash="hash"
        :user="user"
        :is-deleted="!!activity.deleted_at"
        :fixedActivitiesCount="fixedActivitiesCount"
        @updateFixedActivitiesCount="updateFixedActivitiesCount"
        :isFixedActivity="activity.fixed"
        @unpinActivity="updateActivityFixation"
      />
      <LeadForWhatsChat
        v-else-if="activity.type.key === 'whatsapp'"
        :chat="activity"
        :lead="lead ? lead : deal.lead"
      />
      <hr
        class="divider"
        v-if="index != internalActivities.length - 1"
      >
    </div>
    <div v-if="internalNextPageUrl" class="load-more-container">
      <a href="#" @click.prevent="loadMoreActivities" class="load-more-link">Ver Mais</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['activities', 'deal', 'hash', 'user', 'lead', 'nextPageUrl', 'currentPage'],

  data() {
    return {
      internalCurrentPage: this.currentPage,
      internalActivities: this.activities,
      internalNextPageUrl: this.nextPageUrl,      
      ACTIVITY_TYPES: ['call', 'note', 'email', 'meeting', 'proposal', 'visit'],
      fixedActivitiesCount: 0,
      fixedActivities: []
    }
  },

  created() {
    this.groupGalleryMessages();
  },

  watch: {
    activities: {
      handler(newActivities) {
        this.internalActivities = newActivities;
      },
      immediate: true,
      deep: true
    },
    nextPageUrl: {
      handler(newNextPageUrl) {
        this.internalNextPageUrl = newNextPageUrl;
      },
      immediate: true
    },
    currentPage: {
      handler(newPage) {
        this.internalCurrentPage = newPage;
      },
      immediate: true
    },
    fixedActivities: {
      handler() {
        this.fixedActivitiesCount = this.fixedActivities.length;
      },
      immediate: true
    },
  },

  _methods: {
    canFixActivity(activity) {
      if (activity.fixed) {
        return false;
      }

      if (this.checkIfActivityIsAlreadyFixed(activity)) {
        return false;
      }

      return activity.type !== 'note' && activity.type !== 'call';
    },

    checkIfActivityIsAlreadyFixed(activity) {
      return this.internalActivities.find(a => a.id === activity.id && a.fixed);
    },

    updateActivityFixation(activityData) {
      this.$http.put(`/lead/${this.hash}/activity/${activityData.activity?.id}`, {
        fixed: activityData.isFixing
      }).then(() => {
        this.$emit('fetch-activities');
      }).catch((error) => {
        if (error.status === 422) {
          Alert.error(error.data.error);
        }
        console.error('Error marking activity as fixed', error);
      });
    },

    updateFixedActivitiesCount(activity) {
      if (this.canFixActivity(activity)) {
        this.fixedActivitiesCount += 1;
        this.updateActivityFixation(activity);
      }
    },

    setFixedActivities(activities) {
      // this.fixedActivities = activities.filter(activity => activity.fixed);
      this.fixedActivities = activities;
    },

    fetchAllFixedActivities() {
      this.$http.get(`/lead/${this.hash}/fixed-activities?${this.deal?.id ? 'deal=' + this.deal?.id : ''}`)
        .then((res) => {
          this.setFixedActivities(res.data);
        })
        .catch((error) => {
          console.error('Some goes wrong to fetch fixed activities: ' + error?.message);
        });
    },

    getFixedActivitiesCount() {
      return this.fixedActivitiesCount;
    },

    openDocsModal() {
      Bus.$emit('openDocsModal', 'registers');
    },

    openMediaModal() {
      Bus.$emit('openMediaModal', 'registers');
    },

    groupGalleryMessages() {
      this.internalActivities.forEach((activity) => {
        if (!activity.attendence) return;

        const galleryGroups = {};
        const newMessages = [];

        activity.attendence.messages.forEach((message) => {
          if (message.type === 'gallery') {
            const galleryIdentifier = message.message_ref.split('-media')[0];

            if (!galleryGroups[galleryIdentifier]) {
              message.files = [message.file];
              delete message.file;
              galleryGroups[galleryIdentifier] = message;
              newMessages.push(message);
            } else {
              galleryGroups[galleryIdentifier].files.push(message.file);
            }
          } else {
            newMessages.push(message);
          }
        });

        activity.attendence.messages = newMessages;
      });
    },

    updateCurrentPage(newPage) {
      this.internalCurrentPage = newPage;
      this.$emit('update:currentPage', newPage);
    },

    updateActivities(newActivities) {
      this.internalActivities = newActivities;
      this.$emit('update:activities', newActivities);
    },

    updateNextPageUrl(newNextPageUrl) {
      this.internalNextPageUrl = newNextPageUrl;
      this.$emit('update:nextPageUrl', newNextPageUrl);
    },

    loadMoreActivities() {
      if (this.internalNextPageUrl) {
        const page = this.internalCurrentPage + 1;
        this.$http
          .get(`/lead/${this.hash}/activity?page=${page}`)
          .then(({ data }) => {
            const updatedActivities = this.internalActivities.concat(data.data);
            this.updateActivities(updatedActivities);
            this.updateNextPageUrl(data.next_page_url);
            this.updateCurrentPage(page);
            Bus.$emit('listHeightUpdate');
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    onActivityUpdated(content) {
      this.$emit('input-updated', content);
    }
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },

  mounted() {
    this.fixedActivities = this.activities.filter(activity => activity.fixed);
    // this.fetchAllFixedActivities();
  },

  updated () {
    Bus.$emit('listHeightUpdate');
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/variables';
@import '../../../sass/mixins';

.activity-list {
  padding: 16px;
  gap: 12px;
  background-color: #FFF;
}

.divider {
  margin: 0;
}

.activity-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  border-bottom: 1px solid $salesflow-outline-gray-medium;
  padding: 0 8px 8px 8px;
  color: $salesflow-font-gray;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;

  .attachment-buttons {
    display: flex;
    align-items: center;
    gap: 16px;

    button {
      margin: 0px;
      padding: 0px;
      border: 0px;
      outline: 0px;
      line-height: 100%;

      svg {
        background-color: white;
      }

      &:hover ::v-deep svg path {
        fill: $salesflow-primary-hover !important;
      }

      &:focus {
        outline: 0px;
      }
    }
  }
}

.load-more-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.load-more-link {
  color: #71767D;
}

.load-more-link:hover {
  color: #5F33FF;
}
</style>
